import {ActionTree} from 'vuex'
import {WidgetState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {IStep} from "@/apps/MyStudyChoiceOnboardingWidget/models/config-viewmodel"
import axios from "axios";
import {removeQueryString} from "@/apps/MyStudyChoiceOnboardingWidget/composables/queryString";

export default <ActionTree<WidgetState, any>>{
    setConfig(context, payload) {
        context.commit('setConfig', payload)
    },
    setLabels(context, payload) {
        context.commit('setLabels', payload)
    },
    setMyStudyChoice(context, payload) {
        context.commit('setMyStudyChoice', payload)
        context.dispatch('setCanContinue', true)
    },
    setActiveStepIndex(context, payload) {
        context.commit('setActiveStepIndex', payload)
    },
    setActiveSubStepIndex(context, payload) {
        context.commit('setActiveSubStepIndex', payload)
    },
    setSteps(context, payload) {
        context.commit('setSteps', payload)
    },
    setReverse(context, payload) {
        context.commit('setReverse', payload)
    },
    setCanContinue(context, payload) {
        context.commit('setCanContinue', payload)
    },
    setOnboardingIsActive(context, payload) {
        context.commit('setOnboardingIsActive', payload)
    },
    setOnboardingIsCompleted(context, payload) {
        context.commit('setOnboardingIsCompleted', payload)
    },
    setCompleteOnboarding(context) {
        let {getMyStudyChoice} = context.getters
        if (getMyStudyChoice) {
            axios.put(`/api/mystudychoice/mystudychoice/studiekiezerrole/${getMyStudyChoice}`).finally(() => {
                context.dispatch('finalizeOnboarding')
            }).catch(error => {
                throw error
            })
        } else {
            context.dispatch('finalizeOnboarding')
        }
    },
    finalizeOnboarding(context) {
        context.dispatch('setOnboardingIsCompleted', true).then(() =>
            context.dispatch('setOnboardingIsActive', false).then(async () => {
                localStorage?.setItem('my-study-choice-onboarding', '1')
                await removeQueryString(window.location.pathname)
                window.location.reload()
            })
        )
    },
    setNavigateToStep(context, payload) {
        let {getSteps, getActiveStepIndex, getCanContinue} = context.getters;
        if(!getCanContinue) return
        let navigateToIndex = getSteps.findIndex((step: IStep) => step.title == payload.title)
        context.dispatch('setReverse', navigateToIndex <= getActiveStepIndex)
        context.dispatch('setActiveStepIndex', navigateToIndex)
        context.dispatch('setActiveSubStepIndex', 0)
    },
    toggleStep(context, {step}){
        let {getSteps, getActiveStepIndex} = context.getters;
        if (getSteps.length - 1 > getActiveStepIndex) {
            context.dispatch('setActiveStepIndex', step)
        } else {
            throw 'there are no more steps'
        }
    },
    setNextStep(context) {
        let {getSteps, getActiveStepIndex, getActiveSubStepIndex, getCanContinue} = context.getters;
        if(!getCanContinue) return
        context.dispatch('setReverse', false)
        if (getSteps[getActiveStepIndex].subSteps.length) {
            if (getSteps[getActiveStepIndex ? getActiveStepIndex : 0].subSteps.length - 1 > getActiveSubStepIndex) {
                context.dispatch('setActiveSubStepIndex', getActiveSubStepIndex + 1)
            } else {
                context.dispatch('toggleStep', {step: getActiveSubStepIndex + 1})
            }
        } else {
            context.dispatch('toggleStep', {step: getActiveSubStepIndex + 1})
        }
    },
    setPreviousStep(context) {
        context.dispatch('setReverse', false)
        let {getActiveStepIndex, getActiveSubStepIndex} = context.getters;
        if (getActiveSubStepIndex > 0) {
            if (getActiveSubStepIndex > 0) {
                context.dispatch('setReverse', true)
                context.dispatch('setActiveSubStepIndex', getActiveSubStepIndex - 1)
            } else {
                getActiveStepIndex > 0 && context.dispatch('setPreviousStepIndex')
            }
        } else {
            context.dispatch('setReverse', true)
            getActiveStepIndex > 0 && context.dispatch('setActiveStepIndex', getActiveStepIndex - 1)
        }
    }
}
